import React, { PropsWithChildren } from 'react';
import {
  QueryClient,
  QueryClientProvider as BaseQueryClientProvider,
} from '@tanstack/react-query';
import wait from './wait';

export const queryClient = new QueryClient();

const REFETCH_DELAYS_MS = [1000, 3000, 6000];

export function refetchActiveQueries() {
  return queryClient.refetchQueries({ type: 'active' });
}

export async function refetchActiveQueriesDelayed(
  onStep?: () => void | Promise<void>,
) {
  for (const delay of REFETCH_DELAYS_MS) {
    await wait(delay);
    await onStep?.();
    await refetchActiveQueries();
  }
}

const QueryClientProvider = ({ children }: PropsWithChildren) => (
  <BaseQueryClientProvider client={queryClient}>
    {children}
  </BaseQueryClientProvider>
);

export default QueryClientProvider;
